'use strict';
import * as $j_com$002eraquo$002elaminar$002ekeys$002e$002dKey from "./com.raquo.laminar.keys.-Key.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_keys_EventProp(name) {
  this.v7 = null;
  this.v7 = name;
}
export { $c_Lcom_raquo_laminar_keys_EventProp as $c_Lcom_raquo_laminar_keys_EventProp };
$p = $c_Lcom_raquo_laminar_keys_EventProp.prototype = new $j_com$002eraquo$002elaminar$002ekeys$002e$002dKey.$h_Lcom_raquo_laminar_keys_Key();
$p.constructor = $c_Lcom_raquo_laminar_keys_EventProp;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_EventProp() {
}
export { $h_Lcom_raquo_laminar_keys_EventProp as $h_Lcom_raquo_laminar_keys_EventProp };
$h_Lcom_raquo_laminar_keys_EventProp.prototype = $p;
var $d_Lcom_raquo_laminar_keys_EventProp = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_keys_EventProp, "com.raquo.laminar.keys.EventProp", ({
  il: 1,
  a6: 1
}));
export { $d_Lcom_raquo_laminar_keys_EventProp as $d_Lcom_raquo_laminar_keys_EventProp };
